import { FormSectionWrapper } from "./FormSectionWrapper"
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useState } from "react";
import { DocumentImageModal } from "./Modals/DocumentImageModal";
import { commercialInvoiceSource, eeiFiling, ftrExemptionCodes, shipmentPurpose, certOfOriginSource } from "../utils/dropdownOptions";
import { CommercialInvoiceDetailsModal } from "./Modals/CommercialInvoiceDetailsModal";
import { LoadingSpinner } from "./LoadingSpinner";
import axios from 'axios';
import { useNotifications } from "../contexts/NotificationsContext";
import { printBase64Pdf } from "../utils/print";

export const Customs = ({ formik, isReturnShipmentTab }) => {
    const { addNotification } = useNotifications();
    const [showImgModal, setShowImgModal] = useState(false);
    const [showCommercialInvoiceModal, setShowCommercialInvoiceModal] = useState(false);
    const [generateCiLoading, setGenerateCiLoading] = useState(false);
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;

    const handleShowImgModal = () => setShowImgModal(true);
    const handleCloseImgModal = () => setShowImgModal(false);
    const handleShowCommercialInvoiceModal = () => setShowCommercialInvoiceModal(true);
    const handleCloseCommercialInvoiceModal = () => setShowCommercialInvoiceModal(false);

    const handleCommercialInvoiceUpload = (e) => {
        const commercialInvoiceField = isReturnShipmentTab ? 'returnData.commercialInvoice' : 'commercialInvoice';
        formik.setFieldValue(commercialInvoiceField, e.target.files[0]);
    }
    const handleCertOfOriginUpload = (e) => {
        const certOfOriginField = isReturnShipmentTab ? 'returnData.certOfOrigin' : 'certOfOrigin';
        formik.setFieldValue(certOfOriginField, e.target.files[0]);
    }

    const customCheckChange = (e, dropdownName) => {
        formik.handleChange(e);
        const formikField = isReturnShipmentTab ? `returnData.${dropdownName}` : dropdownName;
        if (e.target.checked === false) {
            formik.setFieldValue(formikField, '');
        }
    }

    const generateCommercialInvoice = async () => {
        // TODO revisit this. Do any fields need to be swapped? What would That require for this endpoint?
        setGenerateCiLoading(true);
        const url = `${process.env.REACT_APP_BASE_URL}/fedex/generate/CI`;
        try {
            const result = await axios.post(url, formik.values);
            const data = result.data.data;
            printBase64Pdf(data.encodedFile);
            setGenerateCiLoading(false);
        } catch (err) {
            setGenerateCiLoading(false);
            addNotification('Error generating commercial invoice.', err.message, 'danger');
            console.log('Error generating commercial invoice: ' + err);
        }
    }

    return (
        <>
            <FormSectionWrapper title='Customs information'>
                <Form.Group className='form-group'>
                    <Form.Label>Shipment purpose</Form.Label>
                    <Form.Select
                        id={isReturnShipmentTab ? 'returnData.shipmentPurpose' : 'shipmentPurpose'}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.shipmentPurpose' : 'shipmentPurpose')}
                    >
                        <option value=''>Select an option</option>
                        {
                            shipmentPurpose.map((i) => (
                                <option key={i.value} value={i.value}>{i.key}</option>
                            ))
                        }
                    </Form.Select>
                </Form.Group>
                <Form.Check
                    id={isReturnShipmentTab ? 'returnData.electronicallyUploadTradeDocs' : 'electronicallyUploadTradeDocs'}
                    type='checkbox'
                    label='Electronically upload trade documents'
                    checked={values.electronicallyUploadTradeDocs}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.electronicallyUploadTradeDocs' : 'electronicallyUploadTradeDocs')}
                />
            </FormSectionWrapper>
            <FormSectionWrapper title='Customs documents'>
                <div className='customs-spacing'>
                    <Form.Group>
                        <Form.Label>
                            <Form.Check
                                id={isReturnShipmentTab ? 'returnData.includeCommercialInvoicePf' : 'includeCommercialInvoicePf'}
                                type='checkbox'
                                label='Commercial invoice/proforma'
                                checked={values.includeCommercialInvoicePf}
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.includeCommercialInvoicePf' : 'includeCommercialInvoicePf')}
                                onChange={(e) => customCheckChange(e, 'commercialInvoicePfSource')}
                            />
                        </Form.Label>
                        <Form.Select className='form-group'
                            id={isReturnShipmentTab ? 'returnData.commercialInvoicePfSource' : 'commercialInvoicePfSource'}
                            {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.commercialInvoicePfSource' : 'commercialInvoicePfSource')}
                            disabled={!values.includeCommercialInvoicePf}
                        >
                            <option value=''>Select an option</option>
                            {
                                commercialInvoiceSource.map((i) => (
                                    <option key={i} value={i}>{i}</option>
                                ))
                            }
                        </Form.Select>
                        <Button size='sm' onClick={generateCommercialInvoice} variant='secondary' style={{ marginRight: '0.5rem' }}>
                            {generateCiLoading ? <LoadingSpinner /> : 'Generate Commercial Invoice now'}
                        </Button>
                        <br />
                        <small>Will generate based on current form inputs.</small>
                    </Form.Group>
                    {values.commercialInvoicePfSource.includes('generated') &&
                        <>
                            <div>
                                <Form.Check
                                    id={isReturnShipmentTab ? 'returnData.insertLetterheadImg' : 'insertLetterheadImg'}
                                    type='checkbox'
                                    label='Insert Letterhead Image'
                                    checked={values.insertLetterheadImg}
                                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.insertLetterheadImg' : 'insertLetterheadImg')}
                                />
                                <Form.Check
                                    id={isReturnShipmentTab ? 'returnData.insertSignatureImg' : 'insertSignatureImg'}
                                    type='checkbox'
                                    label='Insert Signature Image'
                                    checked={values.insertSignatureImg}
                                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.insertSignatureImg' : 'insertSignatureImg')}
                                />
                            </div>
                            <div>
                                <Button className='img-upload-btn' size='sm' onClick={handleShowImgModal} variant='secondary'>Upload document images</Button>
                                <br />
                                <Button size='sm' onClick={handleShowCommercialInvoiceModal} variant='secondary'>Add more info</Button>
                            </div>
                        </>
                    }
                    {values.commercialInvoicePfSource.includes('upload now') &&
                        <Form.Group>
                            <Form.Label>Upload document</Form.Label>
                            <Form.Control
                                id='commercialInvoice'
                                name='commercialInvoice'
                                type='file'
                                accept='application/pdf'
                                onChange={handleCommercialInvoiceUpload}
                            />
                        </Form.Group>
                    }
                </div>
                <div className='customs-spacing'>
                    <Form.Group className='form-group'>
                        <Form.Label>
                            <Form.Check
                                type='checkbox'
                                label='USMCA/T-MEC/CUSMA Certification of origin'
                                id={isReturnShipmentTab ? 'returnData.includeCertOfOrigin' : 'includeCertOfOrigin'}
                                checked={values.includeCertOfOrigin}
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.includeCertOfOrigin' : 'includeCertOfOrigin')}
                                onChange={(e) => customCheckChange(e, 'certOfOriginSource')}
                            />
                        </Form.Label>
                        <Form.Select
                            id={isReturnShipmentTab ? 'returnData.certOfOriginSource' : 'certOfOriginSource'}
                            {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.certOfOriginSource' : 'certOfOriginSource')}
                            disabled={!values.includeCertOfOrigin}
                        >
                            <option value=''>Select method of completion</option>
                            {
                                certOfOriginSource.map((i) => (
                                    <option key={i} value={i}>{i}</option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>
                    {values.certOfOriginSource.includes('generated') &&
                        <>
                            <Button size='sm' variant='secondary'>View/edit</Button>
                            <Button size='sm' onClick={handleShowImgModal} variant='secondary'>Upload document images</Button>
                        </>
                    }
                    {values.certOfOriginSource.includes('upload now') &&
                        <Form.Group>
                            <Form.Label>Upload document</Form.Label>
                            <Form.Control
                                id='certOfOrigin'
                                name='certOfOrigin'
                                type='file'
                                accept='application/pdf'
                                onChange={handleCertOfOriginUpload}
                            />
                        </Form.Group>
                    }
                </div>
                <div className='customs-spacing'>
                    <Form.Group>
                        <Form.Label>
                            <Form.Check
                                type='checkbox'
                                label='AES/EEI (formerly SED)'
                                id={isReturnShipmentTab ? 'returnData.includeEei' : 'includeEei'}
                                checked={values.includeEei}
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.includeEei' : 'includeEei')}
                                onChange={(e) => customCheckChange(e, 'eeiSource')}
                            />
                        </Form.Label>
                        <Form.Select
                            id={isReturnShipmentTab ? 'returnData.eeiSource' : 'eeiSource'}
                            {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.eeiSource' : 'eeiSource')}
                            disabled={!values.includeEei}
                        >
                            <option value=''>Select an option</option>
                            {
                                eeiFiling.map((i) => (
                                    <option key={i.value} value={i.value}>{i.key}</option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>
                    {values.eeiSource === 'NO_EEI_REQUIRED' &&
                        <Form.Group>
                            <Form.Label>FTR Exemption</Form.Label>
                            <Form.Select
                                id={isReturnShipmentTab ? 'returnData.ftrExemption' : 'ftrExemption'}
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.ftrExemption' : 'ftrExemption')}
                            >
                                <option value=''>Select an option</option>
                                {
                                    ftrExemptionCodes.map((i) => (
                                        <option key={i} value={i}>{i}</option>
                                    ))
                                }
                            </Form.Select>
                        </Form.Group>
                    }
                </div>
            </FormSectionWrapper>
            <DocumentImageModal
                formik={formik}
                show={showImgModal}
                handleClose={handleCloseImgModal}
                isReturnShipmentTab={isReturnShipmentTab}
            />
            <CommercialInvoiceDetailsModal
                formik={formik}
                show={showCommercialInvoiceModal}
                handleClose={handleCloseCommercialInvoiceModal}
                isReturnShipmentTab={isReturnShipmentTab}
            />
        </>
    )
}
